import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { FaWhatsapp, FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import { content, contactInfo } from '../data/mock';
import './Contact.css';

const Contact = ({ language }) => {
  const t = content[language].contact;
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validar que todos los campos requeridos estén completos
    if (!formData.name || !formData.phone || !formData.email || !formData.service) {
      alert(language === 'en' ? 'Please fill in all required fields' : 'Por favor completa todos los campos requeridos');
      return;
    }
    
    const subject = encodeURIComponent(`Cotización de ${formData.service}`);
    const body = encodeURIComponent(
      `Nombre: ${formData.name}\n` +
      `Teléfono: ${formData.phone}\n` +
      `Email: ${formData.email}\n` +
      `Servicio: ${formData.service}\n\n` +
      `Mensaje:\n${formData.message || 'No message provided'}`
    );
    
    // Abrir cliente de correo
    window.location.href = `mailto:${contactInfo.email}?subject=${subject}&body=${body}`;
    
    // Resetear formulario después de enviar
    setTimeout(() => {
      setFormData({
        name: '',
        phone: '',
        email: '',
        service: '',
        message: ''
      });
    }, 1000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact">
      <div className="container contact-grid">
        <div className="contact-card">
          <h2 style={{ marginTop: 0 }}>{t.title}</h2>
          <div className="contact-row">
            <div className="contact-icon">
              <Phone size={18} />
            </div>
            <div>
              <strong>Phone</strong>
              <br />
              <a href={`tel:${contactInfo.phone}`}>{t.phone}</a>
            </div>
          </div>
          <div className="contact-row">
            <div className="contact-icon">
              <FaWhatsapp size={18} />
            </div>
            <div>
              <strong>WhatsApp</strong>
              <br />
              <a
                href={contactInfo.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.whatsapp}
              </a>
            </div>
          </div>
          <div className="contact-row">
            <div className="contact-icon">
              <Mail size={18} />
            </div>
            <div>
              <strong>Email</strong>
              <br />
              <a href={`mailto:${contactInfo.email}`}>{t.email}</a>
            </div>
          </div>
          <div className="contact-row">
            <div className="contact-icon">
              <MapPin size={18} />
            </div>
            <div>
              <strong>Area</strong>
              <br />
              {t.area}
            </div>
          </div>
          <div className="contact-row">
            <div className="contact-icon">
              <Clock size={18} />
            </div>
            <div>
              <strong>{t.scheduleLabel}</strong>
              <br />
              {t.scheduleText}
            </div>
          </div>
          <div className="socials">
            <a
              href={contactInfo.socialLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="social-fb"
            >
              <FaFacebook size={16} /> Facebook
            </a>
            <a
              href={contactInfo.socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="social-ig"
            >
              <FaInstagram size={16} /> Instagram
            </a>
            <a
              href={contactInfo.socialLinks.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              className="social-tt"
            >
              <FaTiktok size={16} /> TikTok
            </a>
            <a
              href={contactInfo.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="social-wa"
            >
              <FaWhatsapp size={16} /> WhatsApp
            </a>
          </div>
          <p className="tip">{t.tip}</p>
        </div>

        <div className="contact-card">
          <h2 style={{ marginTop: 0 }}>{t.formTitle}</h2>
          <form className="form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder={t.formPlaceholders.name}
              required
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="tel"
              name="phone"
              placeholder={t.formPlaceholders.phone}
              required
              value={formData.phone}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder={t.formPlaceholders.email}
              required
              value={formData.email}
              onChange={handleChange}
            />
            <select
              name="service"
              value={formData.service}
              onChange={handleChange}
              required
            >
              <option value="">{t.formPlaceholders.service}</option>
              {t.serviceOptions.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <textarea
              name="message"
              placeholder={t.formPlaceholders.message}
              value={formData.message}
              onChange={handleChange}
            />
            <button className="btn btn-primary" type="submit">
              {t.formSubmit}
            </button>
          </form>
          <p className="form-note">{t.formNote}</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
